// @flow

import React from "react";

type Props = {
  variant?: "filled" | "outlined",
  color: ?string
};

const Gear = ({ variant = "filled", color, ...restProps }: Props) => {
  switch (variant) {
    case "outlined":
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <g clipPath="url(#clip0_2931_2489)">
              <path
                d="M7.99984 10.3337C9.2885 10.3337 10.3332 9.28899 10.3332 8.00033C10.3332 6.71166 9.2885 5.66699 7.99984 5.66699C6.71117 5.66699 5.6665 6.71166 5.6665 8.00033C5.6665 9.28899 6.71117 10.3337 7.99984 10.3337Z"
                stroke={color || "black"}
                strokeWidth="0.933333"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M15 8.93333V7.06667L12.9681 6.72787C12.8459 6.25 12.6583 5.80013 12.4128 5.38667L13.6103 3.7104L12.2896 2.39067L10.6133 3.5872C10.1999 3.34173 9.75 3.15413 9.27213 3.03187L8.93333 1H7.06667L6.72787 3.03187C6.25 3.15413 5.80013 3.34173 5.38667 3.5872L3.7104 2.39067L2.39067 3.7104L3.5872 5.38667C3.34173 5.80013 3.15413 6.25 3.03187 6.72787L1 7.06667V8.93333L3.03187 9.27213C3.15413 9.75 3.34173 10.1999 3.5872 10.6133L2.39067 12.2896L3.7104 13.6093L5.38667 12.4128C5.80013 12.6583 6.25 12.8459 6.72787 12.9681L7.06667 15H8.93333L9.27213 12.9681C9.75 12.8459 10.1999 12.6583 10.6133 12.4128L12.2896 13.6103L13.6093 12.2905L12.4128 10.6133C12.6583 10.1999 12.8459 9.75 12.9681 9.27213L15 8.93333Z"
                stroke={color || "black"}
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_2931_2489">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </>
      );

    case "filled":
    default:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color || "#919EAB"}
          xmlns="http://www.w3.org/2000/svg"
          {...restProps}
        >
          <path d="M17.1401 10.936C17.1761 10.636 17.2001 10.324 17.2001 9.99999C17.2001 9.67599 17.1761 9.36399 17.1281 9.06399L19.1561 7.47999C19.3361 7.33599 19.3841 7.07199 19.2761 6.86799L17.3561 3.54399C17.2361 3.32799 16.9841 3.25599 16.7681 3.32799L14.3801 4.28799C13.8761 3.90399 13.3481 3.59199 12.7601 3.35199L12.4001 0.807994C12.3641 0.567994 12.1601 0.399994 11.9201 0.399994H8.08011C7.84011 0.399994 7.64811 0.567994 7.61211 0.807994L7.25211 3.35199C6.66411 3.59199 6.12411 3.91599 5.63211 4.28799L3.24411 3.32799C3.02811 3.24399 2.77611 3.32799 2.65611 3.54399L0.736107 6.86799C0.616107 7.08399 0.664107 7.33599 0.856107 7.47999L2.88411 9.06399C2.83611 9.36399 2.80011 9.68799 2.80011 9.99999C2.80011 10.312 2.82411 10.636 2.87211 10.936L0.844106 12.52C0.664106 12.664 0.616107 12.928 0.724107 13.132L2.64411 16.456C2.76411 16.672 3.01611 16.744 3.23211 16.672L5.62011 15.712C6.12411 16.096 6.65211 16.408 7.24011 16.648L7.60011 19.192C7.64811 19.432 7.84011 19.6 8.08011 19.6H11.9201C12.1601 19.6 12.3641 19.432 12.3881 19.192L12.7481 16.648C13.3361 16.408 13.8761 16.084 14.3681 15.712L16.7561 16.672C16.9721 16.756 17.2241 16.672 17.3441 16.456L19.2641 13.132C19.3841 12.916 19.3361 12.664 19.1441 12.52L17.1401 10.936ZM10.0001 13.6C8.02011 13.6 6.40011 11.98 6.40011 9.99999C6.40011 8.01999 8.02011 6.39999 10.0001 6.39999C11.9801 6.39999 13.6001 8.01999 13.6001 9.99999C13.6001 11.98 11.9801 13.6 10.0001 13.6Z" />
        </svg>
      );
  }
};

export default Gear;
